module.exports = __webpack_public_path__ + "img/curso-codigos-de-vestimenta.93bdb551.png";